// Contact drawer (.nav-form): open from any [data-navform-open] or a[href$="#contact"],
// close on scrim/button/Escape, trap focus, name the radio groups, and require at
// least one service chip. Ported from the retired Webflow head block navforminit-1.3.0.
export function initNavForm() {
  const d = document,
    p = d.querySelector('.nav-form');
  if (!p) return;
  const panel = p.querySelector('.nav-form__panel'),
    opens = [...d.querySelectorAll('[data-navform-open], a[href$="#contact"]')],
    closes = [...p.querySelectorAll('[data-navform-close]')];
  let last = null;
  if (!panel || !opens.length) return;
  p.querySelectorAll('.chip__input[type="radio"]').forEach((r) => {
    const g = r.getAttribute('data-name');
    if (g) r.name = g;
  });
  p.querySelectorAll('.nav-form__chips').forEach((row) => {
    const boxes = [...row.querySelectorAll('.chip__input[type="checkbox"]')];
    if (!boxes.length) return;
    const atLeastOne = () => {
      const any = boxes.some((b) => b.checked);
      boxes[0].setCustomValidity(any ? '' : 'Please select at least one option.');
    };
    boxes.forEach((b) => b.addEventListener('change', atLeastOne));
    atLeastOne();
  });
  const ex = (v) => opens.forEach((t) => t.setAttribute('aria-expanded', v ? 'true' : 'false'));
  const open = (t) => {
    last = t || null;
    p.classList.add('is-open');
    d.body.classList.add('nav-form-open');
    ex(1);
    const f = panel.querySelector('[data-navform-close]');
    if (f) f.focus();
  };
  const close = (refocus) => {
    if (!p.classList.contains('is-open')) return;
    p.classList.remove('is-open');
    d.body.classList.remove('nav-form-open');
    ex(0);
    d.dispatchEvent(new CustomEvent('navform:close'));
    if (refocus && last && last.focus) last.focus();
    last = null;
  };
  opens.forEach((t) => {
    t.setAttribute('aria-haspopup', 'dialog');
    t.setAttribute('aria-controls', 'nav-form-panel');
    t.setAttribute('aria-expanded', 'false');
    t.addEventListener('click', (e) => {
      e.preventDefault();
      open(t);
    });
  });
  closes.forEach((t) =>
    t.addEventListener('click', (e) => {
      e.preventDefault();
      close(1);
    }),
  );
  d.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close(1);
  });
  panel.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const f = [...panel.querySelectorAll('a[href],button,input,textarea,select')];
    if (!f.length) return;
    const first = f[0],
      lastEl = f[f.length - 1];
    if (e.shiftKey && d.activeElement === first) {
      e.preventDefault();
      lastEl.focus();
    } else if (!e.shiftKey && d.activeElement === lastEl) {
      e.preventDefault();
      first.focus();
    }
  });
}
